import { v4 as uuidv4 } from 'uuid';
import { CustomFile } from '../../interfaces/custom_file.interface';

export class ClassToEdit {
  courseClassId: string;
  name: string;
  number?: number;
  description: string;
  classVideoUrl: string;
  attachments: Array<any>;
  isLocal: boolean;
  acceptClassFilesLimit: number;
  filesToUpload?: Array<CustomFile>;
  isDeletingRemoteAttachment: boolean;
  hidden: boolean;
  messages: Array<{enabled: boolean, messageId: string | null}>;

  constructor() {
    this.courseClassId = uuidv4();
    this.name = '';
    this.description = '';
    this.classVideoUrl = '';
    this.attachments = [];
    this.isLocal = true;
    this.acceptClassFilesLimit = 10;
    this.filesToUpload = [];
    this.isDeletingRemoteAttachment = false;
    this.hidden = false;
    this.messages = [];
  }
}
